import React from "react";
import { useAuth } from "../auth/AuthContext";
import { Navigate } from "react-router-dom";

export default function Home() {
  const { user, loading, signIn } = useAuth();

  if (loading) return null;
  if (user) return <Navigate to="/library" replace />;

  return (
    <div className="min-h-screen bg-gray-950 text-white flex items-center justify-center">
      <div className="text-center max-w-md px-6">
        <h1 className="text-5xl font-bold text-orange-400 mb-2">🎸 Fretboard</h1>
        <p className="text-gray-400 text-lg mb-8">Your guitar practice companion</p>
        <button
          type="button"
          onClick={() => void signIn()}
          className="px-6 py-3 bg-white text-gray-900 font-medium rounded-md hover:bg-gray-100 transition"
        >
          Sign in with Google
        </button>
      </div>
    </div>
  );
}
